module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn-only",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("At Torrey’s words, Rowena stood still. Her figure, half turned away, seemed to shimmer in the sunlight reflected up from the lintel.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Stunned at her own discovery, Torrey said, “None of my business. I’m sorry. If you’d’ve wanted me to know, you’d’ve told me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Rowena turned fully around. Her face was pale. “I wish you hadn’t guessed. Nobody else knows.” She slid her hands deep into her pockets, thrust out her chin, and looked squarely at Torrey. She said carefully, distinctly, “I’m going to abort it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the small silence that followed, they stood looking at each other, then Torrey said “Oh?” as though Rowena had merely said "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("It’s a nice day.")]), _vm._v(" She had an odd feeling that Rowena would otherwise shatter into pieces. Then, “Sit down. You can’t just tell me you’re going to abort your baby and then walk out the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Rowena’s look softened. She came back and sank down at the table. Torrey pulled out the chair opposite and sat down. And waited. Then without looking up, Rowena said, “I don’t want to kill my baby. But I’m going to. If I could tell anybody why, it would be you.” Now she did look up at Torrey. “But I can’t. So that’s it. That’s the whole tale. The end. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Finis.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Torrey said, reasonably, “Just tell me this, Rowena, just tell me, so I won’t feel so obtuse: Exactly what are you talking about? You’re pregnant. You don’t want to abort your child but you must. Well, as a friend, is there anything I can do?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Rowena slanted a green-eyed glance at her and managed a half smile. “You "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("are")]), _vm._v(" a caution, Torrey. Thanks for wanting to help me. But you can’t. The subject isn’t up for discussion either.” She got up. Against her plaid shirt her slender neck looked white and vulnerable. “I have to do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Have")]), _vm._v(" to? Oh, please!” Suddenly impatient, Torrey too stood up. She leaned across to Rowena, both hands on the table. “Come "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("on,")]), _vm._v(" Rowena! You have a choice. I under"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("stand")]), _vm._v(" that you’re dying to get your degree. You’ve put in four years — five years? — of backbreaking work. And you’re "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("not")]), _vm._v(" married, but —” She stopped. Something about the way Rowena was standing there told Torrey that she wasn’t hearing. She was in some other place, some far-off dimension from which she now said, so low that Torrey barely heard, “It would be a crime to let this baby be born.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Torrey felt a chill. She looked at Rowena, who now lifted her gaze. Her green eyes stared at Torrey from that other place, wherever it was. “Forget it, Torrey. Don’t try to help me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But — the baby’s father! What about "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("him?")]), _vm._v(" Doesn’t "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("he")]), _vm._v(" have any say?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The father.” Rowena stared at her. “The father? No. No say at all. Torrey, please! Have done with it! I’m going.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Rowena, wait! Let me help.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Stop")]), _vm._v(" it!” Rowena said fiercely. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“Don’t!”")]), _vm._v(" And more quietly, “Do me a favor. Forget all this.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But it was too late to forget. It had been too late from the moment Torrey had guessed so wildly and accurately as Rowena had walked toward the open door of the cottage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“All right,” Torrey said, “not another word. I promise. It’s not my business. But … just one quick question?” She didn’t wait. “How many months pregnant are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Rowena gave an exasperated laugh, “You "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("are")]), _vm._v(" a bulldog, aren’t you, Torrey? You never give up. Is it too late for an abortion? Still not the second trimester. I have about three weeks left before it’ll be too risky.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I see. I was just asking.” Risky. A better word was "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("dangerous.")]), _vm._v(" And in any case, not legal in Ireland. Rowena would have to go to England or elsewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So I have to hurry.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes,” Torrey said. “Before it’s too late.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba396f0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter4.vue
// module id = 81
// module chunks = 0